export default __webpack_public_path__ + "static/media/8.e46d146b.png";